import React, { useEffect } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { Services } from '@/services/services';
import { CurrentSession } from '@/services/repository/session';
import { CleanFailure, emptyFailure, Failure, SaveFailure } from './Model';

export const StartAddFailurePage = () => {
  const navigate = useNavigate()
  const machineId = useParams().machineid

  useEffect(() => {
    if (machineId) {
      CleanFailure(machineId)
      navigate(`/communal/machine/${machineId}/failures/add/page1`, { replace: true })
    } else {
      navigate(`/`, { replace: true })
    }
  }, [machineId, navigate]);

  return null; // No UI needed since it redirects immediately
}


export const goToAddFailurePage = ({ navigate, machineId }: {
  navigate: ReturnType<typeof useNavigate>
  machineId?: string 
}, defaults: Partial<Failure> = {}) => {
  if (!machineId) {
    return
  }
  const failure = {
    ...emptyFailure(),
    ...defaults
  }
  SaveFailure(machineId, failure)
  if(failure.category) {
    navigate(`/communal/machine/${machineId}/failures/add/page2`, { replace: true })
    return
  }
  navigate(`/communal/machine/${machineId}/failures/add/page1`, { replace: true })
}